import DoctorImage from '../../assets/icons/doctor_vector_black.svg';
import LocationImage from '../../assets/icons/location.svg';
import PhoneImage from '../../assets/icons/phone_call.svg';
import ClockImage from '../../assets/icons/clock.svg';
import FileImage from '../../assets/icons/file_info.svg';
import Notimenew from '../../assets/icons/notimenew.svg';

import { useQuery } from 'react-query';
import {
  IMAGE_BASE_URL,
  URL_TO_BANK_PAYMENT_VISIT,
  getDoctor,
  getDoctorVisitTimes
} from '../../core';
import { useNavigate, useParams } from 'react-router-dom';
import { CustomLoader } from '../../components/basic/loader';
import { useCallback, useEffect, useState } from 'react';
import { Datepicker } from '@ijavad805/react-datepicker';
import { Input } from 'rsuite';
import { convertToJalali } from '../../utils/helpers';
import { useModal } from '../../contexts/modal';
// import Cookies from 'js-cookie';

export const Reserve = () => {
  // eslint-disable-next-line no-unused-vars
  const navigate = useNavigate();
  // const { user } = useUser();
  const { id } = useParams();
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [loading, setLoading] = useState(false);
  const [visitTimes, setVisitTimes] = useState([]);
  const { handleOpen } = useModal();

  const handleReservedoctor = (value: string) => {
    return async (val = value) => {
      window.location.replace(
        `${URL_TO_BANK_PAYMENT_VISIT}Bearer ${localStorage.getItem('token')}&visit_id=${val}&came_from=pwa&discount_code=`
      );
    };
  };
  const doctor = useQuery({
    queryKey: ['doctor', id],
    queryFn: async () => {
      const res = await getDoctor(parseInt(id ?? '-1'));
      if (res.data.state === 'error') {
        return {};
      }
      return res.data;
    }
  });
  const handleGetDoctorVisitTimes = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (value: any) => {
      (async () => {
        setLoading(true);
        setSelectedDate(value);

        try {
          setVisitTimes([]);
          const { status, data } = await getDoctorVisitTimes(
            parseInt(id ?? '-1'),
            convertToJalali(new Date(value))
          );
          if (status === 200) {
            setVisitTimes(data.visit_times);
          }
        } catch (e) {
          console.log(e);
        }
        setLoading(false);
      })();
    },
    []
  );

  useEffect(() => {
    handleGetDoctorVisitTimes(new Date());
  }, []);

  if (doctor.isLoading) {
    return <CustomLoader />;
  }
  return (
    <>
      <div
        key={doctor.data.id.toString()}
        className="flex flex-col p-2 pb-4 bg-[--rs-soft-blue] min-h-[100%]">
        <div className="flex justify-between">
          <img
            className="w-[40%] h-fit m-auto"
            style={{ aspectRatio: 623 / 523 }}
            src={`${IMAGE_BASE_URL}/${doctor.data.image_of_doctor}`}
            alt={doctor.data.doctor_name}
          />
          <div className="w-[60%] flex flex-col text-sm justify-between px-2 mt-1">
            <div className="mb-2 flex text-base1">
              <img className="w-5 ml-2" src={DoctorImage} alt="" />
              <span>
                {doctor.data.doctor_name} {doctor.data.doctor_family}
              </span>
            </div>
            <div className="mb-2 flex text-sm">
              <img className="w-5 ml-2" src={LocationImage} alt="" />
              <span>{doctor.data.office_address}</span>
            </div>
            <div className="mb-2 flex text-sm">
              <img className="w-5 ml-2" src={PhoneImage} alt="" />
              <span>{doctor.data.office_phone_number}</span>
            </div>
          </div>
        </div>
        <div className="mt-2 flex text-sm">
          <img className="w-5 ml-2" src={FileImage} alt="" />
          <span>{doctor.data.write_about_yourself}</span>
        </div>
        <p className="mt-2 text-sm">
          جهت نهایی شدن نوبت ویزیت شما، هزینه ها که شامل : ویزیت پزشک و خدمات زیر ساخت سایت و مالیات
          بر ارزش افزوده می باشد، از طریق اپلیکیشن دریافت می شود و شما نیازی به پرداخت در مطب پزشک
          ندارید. البته هزینه دستمزد خدمات دیگر غیر از ویزیت پزشک، که در مطب ارایه می شود، جداگانه
          در مطب دریافت خواهد شد.{' '}
        </p>
        <div className="px-3 mt-5">
          <div className="mb-1 text-sm mt-3">تاریخ موردنظر را انتخاب کنید</div>
          <Datepicker
            lang={'fa'}
            theme={'green'}
            input={
              <Input
                className="w-full"
                placeholder="تاریخ را انتخاب کنید"
                value={new Intl.DateTimeFormat('fa-IR', {
                  weekday: 'long',
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric'
                }).format(selectedDate)}
              />
            } // whatever you want
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            onChange={(val: any) => {
              handleGetDoctorVisitTimes(val);
            }}
          />
          <div className="mb-3"></div>

          {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
          {visitTimes.map((item: any) => {
            return (
              <div
                key={item.id}
                className="shadow-[0_1px_3px_0px_rgba(0,0,0,0.2)]  rounded-lg p-2 bg-[--rs-white] cursor-pointer"
                onClick={() =>
                  handleOpen(
                    handleReservedoctor,
                    item.id,
                    `رزرو نوبت پزشک در تاریخ: ${item.visit_date} و ساعت : ${item.from_time} و با هزینه رزرو ${item.visit_cost} ریال در حال انجام است، جهت تغییر تاریخ یا ساعت نوبت دکمه انصراف را زده و نوبت خالی دیگری را انتخاب کنید.`,
                    'تایید و رزرو نوبت پزشک',
                    'رزرو نوبت',
                    'انصراف'
                  )
                }>
                {/* body = 'آیا از تصمیم خود اطمینان دارید؟',
      title = '',
      okButton = 'بلی',
      closeButton = 'خیر' */}
                <div className="mb-2 flex text-base1">
                  <img className="w-5 ml-2" src={DoctorImage} alt="" />
                  <span>پزشک معالج : {item.doctor_name_family}</span>
                </div>
                <div className="mb-2 flex text-base1">
                  <img className="w-5 ml-2" src={ClockImage} alt="" />
                  <span>زمان حضور در مطب</span>
                </div>
                <div className="mb-2 flex text-base1 justify-around">
                  <span className="text-basesm">روز: {item.visit_date}</span>
                  <span className="text-basesm">ساعت: {item.from_time}</span>
                </div>
                <div className="mb-2 flex text-base1">هزینه نوبت دهی: {item.visit_cost} ریال</div>
              </div>
            );
          })}

          {loading ? (
            <CustomLoader />
          ) : visitTimes.length === 0 ? (
            <>
              <img src={Notimenew} className="mx-auto mt-5" alt="" />
              <div className="text-center font-base">
                در این تاریخ پزشک نوبت ویزیت ندارد، با تغییر تاریخ روز های دیگر را نیز برسی کنید.
              </div>
            </>
          ) : null}
        </div>
      </div>
    </>
  );
};
